namespace Matrix.Data {
    export enum CustomDateSourceData {
        AccountHoldings = 1,
        Ownership = 2
    }
    Serenity.Decorators.registerEnumType(CustomDateSourceData, 'Matrix.Data.CustomDateSourceData');
}
